import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ElementRef, HostListener } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { SliderModelService } from '../../../../services/infrastructure/sliderModel.service';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { NgbDateStruct, NgbCalendar, NgbDate, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { SraOrdersService } from '../../../../services/cpp/sra-orders.service';
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import { MatCalendar, MatDatepicker } from '@angular/material/datepicker';

@Component({
  selector: 'app-sra-request-details',
  templateUrl: './sra-request-details.component.html',
  styleUrls: ['./sra-request-details.component.scss'],
  providers: [DatePipe]
})
export class SraRequestDetailsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('detailsPaginator', { static: false }) detailsPaginator: MatPaginator;
  @ViewChild('calendar') matcalendar: MatCalendar<Date>;
  @ViewChild('picker') datepicker: MatDatepicker<any>;
  @ViewChild('datepickerFooter') datepickerFooter: ElementRef;
  @ViewChild('calendarContainer') calendarContainer!: ElementRef;

  private subscription = new Array<Subscription>();
  displayedColumns: string[] = [];
  sraRequestDetailsDataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  masterConstants = MasterConstants;
  isApproveRequest: boolean = false;
  plAccess: boolean = false;
  selectedCount: number = 0;
  isAllItemSelected: boolean = false;
  isItemAvailable: boolean = false;
  private pendingData: any = null;
  showTabs = false;
  tabNode: string;
  fromPlaceOrder: boolean = false;
  hasModifyItem: boolean = false;
  date = new Date();
  maxDate = new Date(this.date.setMonth(this.date.getMonth() + 6));
  maxDateBulk = new Date();
  isWeekendForNonSDM = (date: NgbDate) => this.calendar.getWeekday(date) >= 6;

  // Date picker properties
  todayDate: NgbDateStruct;
  isAccountSDM: boolean = false;
  reasonList: any[] = [];
  selectedWeekdays = [];
  sdmSystemGeneratedDate?: Date = null;

  datemodel: NgbDateStruct;
  requestDatemodel: NgbDateStruct;
  isWeekend = (date: NgbDate) => this.calendar.getWeekday(date) == 7;
  isHoliday = (date: NgbDate) => this.getIsHoliday(date);
  isRequestHoliday = (date: NgbDate, data: any) => this.getIsRequestHoliday(date, data);
  requestDateType = (date: NgbDate, data: any) => this.getRequestDateType(date, data);
  minDelDate: any;
  configurationMessage: any[];
  bulkItemTimeFrame: any;

  // Define which columns to show in the details view
  private allowedColumns = [
    'action',
    'account',
    'location',
    'deliveryLocation',
    'manufacturer',
    'itemNumber',
    'productName',
    'orderUOM',
    'requestedQTY',
    'requestedArrivalDate',
    'arrivalDateReasonChange'
  ];

  filteredValues = {
    productName: ''
  };

  constructor(
    public sliderModelService: SliderModelService,
    private datePipe: DatePipe,
    private sraOrdersService: SraOrdersService,
    private loaderService: LoaderService,
    private calendar: NgbCalendar,
    public config: NgbDatepickerConfig,
    public configDate: NgbCalendar,
    private toastrService: ToastrService,
    private localStorageService: LocalStorageService,
  ) {
    const now = new Date();
    this.todayDate = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
    this.config.minDate = this.todayDate;
    this.config.maxDate = { year: now.getFullYear(), month: now.getMonth() + 7, day: now.getDate() };
  }

  ngOnInit(): void {
    if (this.localStorageService.get(MasterConstants.CPP_ERROR_CONFIG_MESSAGE)) {
      this.configurationMessage = JSON.parse(this.localStorageService.get(MasterConstants.CPP_ERROR_CONFIG_MESSAGE));
      
      if (this.configurationMessage.filter(x => x.id === 'BULK_ITEM_TIME_FRAME').length > 0) {
        this.bulkItemTimeFrame = this.configurationMessage.filter(x => x.id === 'BULK_ITEM_TIME_FRAME')[0].value;
      }
      else {
        this.bulkItemTimeFrame = 12;
      }
      this.maxDateBulk = new Date(this.date.setMonth(parseInt(this.bulkItemTimeFrame)));
    }
    this.subscription.push(
      this.sliderModelService.sraRequestDetailsSliderValue.subscribe(data => {
        if (data) {
          this.pendingData = data;
          if (this.detailsPaginator) {
            this.loadGridData(data);
          }
        }
      })
    );
  }

  ngAfterViewInit(): void {
    if (this.pendingData) {
      setTimeout(() => {
        this.loadGridData(this.pendingData);
        this.pendingData = null;
      }, 0);
    }
  }

  // Detect clicks outside the calendar to close it (matching cpp-create-order)
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    if (
      this.calendarContainer &&
      !this.calendarContainer.nativeElement.contains(event.target)
    ) {
      if (this.sraRequestDetailsDataSource && this.sraRequestDetailsDataSource.data) {
        this.sraRequestDetailsDataSource.data.forEach(x => {
          if (x.openDatepicker) {
            x.openDatepicker = false;
          }
        });
      }
    }
  }

  private loadGridData(data: any): void {
    this.isApproveRequest = data.isApproveRequest;
    this.fromPlaceOrder = data.requestItemIds.length > 0;
    if (this.fromPlaceOrder) {
      const el = document.querySelector('.close-btn') as HTMLElement;
      if (el) el.style.display = 'none';
    }
    this.plAccess = data.plAccess;

    this.displayedColumns = data.displayedColumns.filter(col => this.allowedColumns.includes(col));

    this.displayedColumns.push('requestedArrivalDate');
    this.displayedColumns.push('arrivalDateReasonChange');

    // Load SDM weekdays and account SDM flag if available
    //if (data.selectedWeekdays) {
    //  this.selectedWeekdays = data.selectedWeekdays;
    //}
    //if (data.isAccountSDM !== undefined) {
    //  this.isAccountSDM = data.isAccountSDM;
    //}
    //if (data.reasonList) {
    //  this.reasonList = data.reasonList;
    //}

    let selectedRecordsList: { shipToAccount: any, itemID: any }[] = [];

    if ((data.selectedRecords || []).length === 0) {
      const gridData = data.mainGridData || [];
      selectedRecordsList = gridData.map((rec: any) => ({
        shipToAccount: rec.shipToAccount,
        itemID: rec.itemID
      }));
    } else {
      selectedRecordsList = (data.selectedRecords).map((rec: any) => ({
        shipToAccount: rec.shipToAccount,
        itemID: rec.itemID
      }));
    }

    const filters = {
      selectedRecords: selectedRecordsList,
      requestItemIds: data.requestItemIds
    };

    this.loaderService.setLoaderStatus(true);
    this.subscription.push(
      this.sraOrdersService.getRequestDetailsForSelectedRecords(filters).subscribe(
        (result: any) => {
          // Load reason code list from API response
          if (result.reasonCodeList && result.reasonCodeList.length > 0) {
            this.reasonList = result.reasonCodeList.map((rc: any) => ({
              id: rc.id,
              value: rc.value
            }));
          }

          // Convert datetime to formatted date string
          const dataWithDate = result.itemDetails.map(row => {
            let formattedDate = '';

            if (row.requestedArrivalDate) {
              const dateObj = new Date(row.requestedArrivalDate);
              formattedDate = this.datePipe.transform(dateObj, 'MM/dd/yyyy') || '';
            }

            const selectedDays = this.parseSelectedDays(row.selectedDays);
            const defaultDeliveryDate = row.defaultDeliveryDate ?? row.defaultDelDate;

            return {
              ...row,
              requestedArrivalDate: formattedDate,
              defaultDeliveryDate: defaultDeliveryDate,
              selectedDays: selectedDays,
              arrivalDateReasonChange: row.deliveryDateChangeReason || '',
              openDatepicker: false,
              isReasonMandatory: (row.deliveryDateChangeReason !== '' ? true : false),
              isSelected: false,
              isModified: false
            };
          });

          this.sraRequestDetailsDataSource = new MatTableDataSource(dataWithDate);
          this.sraRequestDetailsDataSource.paginator = this.detailsPaginator;
          this.sraRequestDetailsDataSource.paginator.firstPage();
          this.sraRequestDetailsDataSource.filterPredicate = this.customFilterPredicate();

          this.validateDeliveryDateFilter();
          //this.checkAccountSDMEnabled();
          this.loaderService.setLoaderStatus(false);
        },
        error => {
          console.error('Error loading request details:', error);
          this.loaderService.setLoaderStatus(false);
        }));
  }
  // Sync reason code across rows with same delivery date (matching cpp-create-order)
  reasonCodeChange(element: any): void {
    this.sraRequestDetailsDataSource.data.filter(x => x.sroRequestID === element.sroRequestID).forEach(item => {
      if (item !== element && item.isLineSDM
        && new Date(item.requestedArrivalDate).getTime() == new Date(element.requestedArrivalDate).getTime()) {
        item.arrivalDateReasonChange = element.arrivalDateReasonChange;
      }
    });
    element.isModified = true;
    this.hasModifyItem = true;
  }

  validateDeliveryDateFilter() {
    const currentDate = new Date();
    this.config.minDate = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() };
    this.config.maxDate = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 7, day: currentDate.getDate() };
    // this.datemodel = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() + 4 };//this.configDate.getToday();

    const sdmlines = this.sraRequestDetailsDataSource.data.filter(x => x.isSelected == true /* && x.islinesdm == true*/);
    const selecteLineCount = sdmlines.length;
    if (sdmlines && selecteLineCount > 0) {
      const firstdate = sdmlines[0].requestedArrivalDate;
      if (firstdate !== null && firstdate !== undefined && firstdate !== '') {
        const datecount = sdmlines.filter(x => new Date(x.requestedArrivalDate).getTime() == new Date(firstdate).getTime()).length;
        if (datecount == selecteLineCount) {
          const fDate = new Date(firstdate);
          this.datemodel = { year: fDate.getFullYear(), month: fDate.getMonth() + 1, day: fDate.getDate() };
        }
        else {
          this.datemodel = this.configDate.getToday();
        }
      }
      else {
        this.datemodel = this.configDate.getToday();
      }
    }
    else {
      this.datemodel = this.configDate.getToday();
    }

    this.tabNode = '';
  }

  // Validate delivery date filter and set requestDatemodel (matching cpp-create-order)
  validateRequestDeliveryDateFilter(data: any) {
    const currentDate = new Date();
    this.config.minDate = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() };
    //this.config.maxDate = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 7, day: currentDate.getDate() };
    var minDate = new Date();
    minDate.setHours(0, 0, 0, 0);
    const defaultDeliveryDate = data.defaultDeliveryDate ?? data.defaultDelDate;

    if (data.requestedArrivalDate) {
      if (data.bulkPackaged == 'BULK' || !data.isLineSDM) {
        minDate = new Date(defaultDeliveryDate);
        minDate.setHours(0, 0, 0, 0);
      }
      else {
        var programDate = new Date(data.programDate);
        programDate.setHours(0, 0, 0, 0); // strip time

        if (programDate.getTime() > minDate.getTime()) {
          minDate = programDate;
        }
      }

      this.minDelDate = { year: minDate.getFullYear(), month: minDate.getMonth() + 1, day: minDate.getDate() };
      const fDate = new Date(data.requestedArrivalDate);
      fDate.setHours(0, 0, 0, 0); // strip time

      if (fDate.getTime() < minDate.getTime()) {
        this.requestDatemodel = null;
      }
      else {
        this.requestDatemodel = { year: fDate.getFullYear(), month: fDate.getMonth() + 1, day: fDate.getDate() };
      }
    }
    else {
      if (data.bulkPackaged == 'BULK' || !data.isLineSDM) {
        minDate = new Date(defaultDeliveryDate);
        minDate.setHours(0, 0, 0, 0);
      }
      else {
        var programDate = new Date(data.programDate);
        programDate.setHours(0, 0, 0, 0); // strip time

        if (programDate.getTime() > minDate.getTime()) {
          minDate = programDate;
        }
      }
      this.minDelDate = { year: minDate.getFullYear(), month: minDate.getMonth() + 1, day: minDate.getDate() };
      this.requestDatemodel = null;
    }
    const maxDateObj = new Date(minDate);
    maxDateObj.setMonth(minDate.getMonth() + 7);
    this.config.maxDate = { year: maxDateObj.getFullYear(), month: maxDateObj.getMonth() + 1, day: maxDateObj.getDate() };
  }

  // Date selection handler (matching cpp-create-order)
  onDateSelect(date: NgbDateStruct, element: any): void {
    element.openDatepicker = false;
    let delDate: Date;
    if (date == null) {
      delDate = new Date();
    } else {
      delDate = new Date(date.year, date.month - 1, date.day);
    }

    element.requestedArrivalDate = this.datePipe.transform(delDate, 'MM/dd/yyyy');
    element.isItemEligible = true;
    element.isModified = true;
    this.hasModifyItem = true;
    this.validateDate(element);
  }

  openCalendar(data: any) {
    // Close any other open datepickers first
    if (this.sraRequestDetailsDataSource && this.sraRequestDetailsDataSource.data) {
      this.sraRequestDetailsDataSource.data.forEach(x => {
        if (x !== data && x.openDatepicker) {
          x.openDatepicker = false;
        }
      });
    }
    setTimeout(() => {
      this.validateRequestDeliveryDateFilter(data);
      data.openDatepicker = true;
    }, 100);
  }

  closeCalendar(element: any, event?: MouseEvent): void {
    // Delay removal slightly to ensure Angular updates the DOM
    setTimeout(() => {
        event?.stopPropagation();
        element.openDatepicker = false;
    }, 100);
  }

 
  // Validate date with reason code sync
  validateDate(element: any, event?: any): void {
    element.isItemEligible = true;
    element.isModified = true;
    this.hasModifyItem = true;
    if (element.isLineSDM) {
      this.sraRequestDetailsDataSource.data.forEach(item => {
        if (item !== element && item.isLineSDM
          && new Date(item.requestedArrivalDate).getTime() == new Date(element.requestedArrivalDate).getTime()) {
          element.arrivalDateReasonChange = item.arrivalDateReasonChange;
          return;
        }
      });
      this.reasonCodeRequire(element);

    }

  }

  // Determine if reason code is required
  reasonCodeRequire(element: any): void {
    if (element.isLineSDM) {
      const dDate = new Date(element.requestedArrivalDate);
      const ngDate: NgbDate = new NgbDate(dDate.getFullYear(), dDate.getMonth() + 1, dDate.getDate());
      const selectedDays = element.selectedDays?.length ? element.selectedDays : this.selectedWeekdays;

      if (selectedDays.some(x => x == this.calendar.getWeekday(ngDate))
        && new Date(element.defaultDeliveryDate ?? element.defaultDelDate).getTime() <= new Date(element.requestedArrivalDate).getTime()) {
        element.isReasonMandatory = false;
        element.arrivalDateReasonChange = '';
      } else {
        element.isReasonMandatory = true;
      }
    }
  }
  //isDisabled = (date: NgbDateStruct): boolean => {
  //  const today = new Date();
  //  today.setHours(0, 0, 0, 0);
  //  const checkDate = new Date(date.year, date.month - 1, date.day);
  //  return checkDate < today;
  //}
  // Highlighting weekdays for SDM lines
  getIsRequestHoliday(date: NgbDate, element: any): boolean {
    const todayDate = new Date();
    if (!element.requestedArrivalDate
      && element.isLineSDM
      && new Date(element.defaultDeliveryDate ?? element.defaultDelDate)
      && new Date(date.year, date.month - 1, date.day) >= new Date(element.defaultDeliveryDate ?? element.defaultDelDate)
      && new Date(date.year, date.month - 1, date.day) >= todayDate) {
      return element.selectedDays?.includes(this.calendar.getWeekday(date));
    }
    else if (element.requestedArrivalDate
      && element.isLineSDM
      && new Date(date.year, date.month - 1, date.day) >= new Date(element.requestedArrivalDate)) {
      return element.selectedDays?.includes(this.calendar.getWeekday(date));
    } else {
      return false;
    }
  }
  showTab(tabid: string) {
    this.tabNode = tabid;
  }
  // Get date type for test id
  getRequestDateType(date: NgbDate, element: any): string {
    let requestDateType = '';
    const selectedDays = element.selectedDays?.length ? element.selectedDays : this.selectedWeekdays;
    if (selectedDays && selectedDays.length > 0) {
      const now = new Date();
      const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
      const calDate = new Date(date.year, date.month - 1, date.day).getTime();
      if (element.isLineSDM && !this.isWeekend(date) && calDate >= todayDate) {
        const delDate = new Date(element.defaultDeliveryDate ?? element.defaultDelDate).getTime();

        if (calDate === delDate) {
          requestDateType = element.itemNumber + '_earliestSchDelDate';
        }
        else if (calDate === todayDate && calDate !== delDate) {
          requestDateType = element.itemNumber + '_earliestUnschDelDate';
        }
        else if (calDate > delDate) {
          const nextEarliestDate = this.getNextEarliestWeekday(new Date(element.defaultDeliveryDate ?? element.defaultDelDate), selectedDays);
          if (calDate === nextEarliestDate.getTime()) {
            requestDateType = element.itemNumber + '_nextEarliestSchDelDate';
          } else {
            const earliestUnschDate = this.getEarliestUnscheduledDay(new Date(todayDate), selectedDays);
            if (calDate === earliestUnschDate.getTime()) {
              requestDateType = element.itemNumber + '_earliestUnschDelDate';
            }
          }
        }
      }
    }
    return requestDateType;
  }

  getNextEarliestWeekday(startDate: Date, selectedWeekdays: number[]): Date {
    const resultDate = new Date(startDate);
    let currentDay = resultDate.getDay() === 0 ? 7 : resultDate.getDay();

    if (selectedWeekdays.includes(currentDay)) {
      resultDate.setDate(resultDate.getDate() + 1);
    }

    while (true) {
      currentDay = resultDate.getDay() === 0 ? 7 : resultDate.getDay();
      if (selectedWeekdays.includes(currentDay)) {
        break;
      }
      resultDate.setDate(resultDate.getDate() + 1);
    }
    return resultDate;
  }

  getEarliestUnscheduledDay(startDate: Date, selectedWeekdays: number[]): Date {
    const resultDate = new Date(startDate.getTime());
    while (true) {
      const day = resultDate.getDay() === 0 ? 7 : resultDate.getDay();
      if (!selectedWeekdays.includes(day)) {
        break;
      }
      resultDate.setDate(resultDate.getDate() + 1);
    }
    return resultDate;
  }
  SetAllFields(field: string, value: any) {
    this.sraRequestDetailsDataSource.data.forEach(item => {
      if (item.isSelected) {
        item.requestedArrivalDate = this.datePipe.transform(new Date(value.year, value.month - 1, value.day), 'MM/dd/yyyy');
        this.validateDate(item);
        item.isSelected = false;
      }
    });

    const updatedData = JSON.parse(JSON.stringify(this.sraRequestDetailsDataSource.data));
    this.sraRequestDetailsDataSource = new MatTableDataSource(updatedData);
    this.sraRequestDetailsDataSource.paginator = this.detailsPaginator;
    this.sraRequestDetailsDataSource.filterPredicate = this.customFilterPredicate();
    this.selectedCount = 0;
    this.isAllItemSelected = false;
    this.showTabs = false;
    this.tabNode = '';
  }

  isAnyLineSMDSelected() {
    //const sdmLines = this.sraRequestDetailsDataSource.data.filter(x => x.isSelected == true && x.isLineSDM == true);
    //if (sdmLines && sdmLines.length > 0) {
    //  if (this.sdmSystemGeneratedDate == null) {
    //    this.sdmSystemGeneratedDate = new Date(sdmLines[0].defaultDeliveryDate ?? sdmLines[0].defaultDelDate);
    //  }
    //  this.selectedWeekdays = sdmLines[0].selectedDays ?? [];
    //}
    //return sdmLines && sdmLines.length > 0;
    return false;
  }
  getIsHoliday(date: NgbDate) {
    const todayDate = new Date();
    const calDate = new Date(date.year, date.month - 1, date.day);
    if (this.selectedWeekdays.length > 0 && calDate >= todayDate) {
      return this.selectedWeekdays.includes(this.calendar.getWeekday(date));
    }
    return false;
  }

  private parseSelectedDays(selectedDays: any): number[] {
    if (!selectedDays) {
      return [];
    }

    if (Array.isArray(selectedDays)) {
      return selectedDays.map((x: any) => Number(x)).filter((x: number) => !isNaN(x));
    }

    if (typeof selectedDays === 'number') {
      return [selectedDays];
    }

    if (typeof selectedDays === 'string') {
      return selectedDays
        .split(/[^0-9]+/)
        .filter(x => x.length > 0)
        .map(x => Number(x))
        .filter(x => !isNaN(x));
    }

    return [];
  }

  customFilterPredicate() {
    const myFilterPredicate = function (data: any, filter: string): boolean {
      const searchString = JSON.parse(filter);
      const itemDescriptionFound = data.productName == null || data.productName.toString().trim().toLowerCase().indexOf(searchString.productName.toLowerCase()) !== -1;
      return itemDescriptionFound;
    };
    return myFilterPredicate;
  }

  filterByItemDesc(event) {
    this.filteredValues['productName'] = event;
    this.sraRequestDetailsDataSource.filter = JSON.stringify(this.filteredValues);
  }

  enableCheckBoxSingle(isChecked) {
    if (isChecked) {
      this.selectedCount = this.sraRequestDetailsDataSource?.data.filter(x => x.isSelected == true).length;
      this.showTabs = true;
      if (this.selectedCount == this.sraRequestDetailsDataSource?.data.length) {
        this.isAllItemSelected = true;
      } else {
        this.isAllItemSelected = false;
      }
    }
    else {
      this.selectedCount = this.sraRequestDetailsDataSource?.data.filter(x => x.isSelected == true).length;
      this.showTabs = false;
      this.isAllItemSelected = false;
    }
    this.showTabs = this.selectedCount > 0;
  }

  enableCheckBoxAll(isChecked) {
    if (isChecked) {
      this.showTabs = true;
      this.sraRequestDetailsDataSource.data.forEach(x => x.isSelected = true);
    } else {
      // Close all open calendars and deselect
      this.showTabs = false;
      this.sraRequestDetailsDataSource.data.forEach(x => {
        x.isSelected = false;
      });
    }
    this.selectedCount = this.sraRequestDetailsDataSource?.data.filter(x => x.isSelected == true).length;
    this.showTabs = this.selectedCount > 0;

  }
  clearProductNameFilter() {
    this.filteredValues.productName = '';
    this.filterByItemDesc('');
  }

  // Save updated dates and reason codes


  closeSlider() {
    // Close any open calendars
    if (this.sraRequestDetailsDataSource && this.sraRequestDetailsDataSource.data) {
      this.sraRequestDetailsDataSource.data.forEach(item => {
        item.openDatepicker = false;
      });
    }

    this.sliderModelService.close();
  }
  updateRequestedDeliveryDate(isContinueClick: boolean) {
    this.loaderService.setLoaderStatus(true);
    var selectedRecords = this.sraRequestDetailsDataSource.data.filter(x => x.isModified == true && x.isItemEligible == true);
    // Validate if any record has isReasonMandatory but no arrivalDateReasonChange selected
    const recordsWithMissingReason = selectedRecords.filter(record =>
      record.isReasonMandatory === true &&
      (!record.arrivalDateReasonChange || record.arrivalDateReasonChange === null || record.arrivalDateReasonChange === '')
    );

    if (recordsWithMissingReason.length > 0) {
      this.loaderService.setLoaderStatus(false); 
      this.toastrService.error("Select Arrival Date Reason Change");
      return;
    }
    const updatePayload = selectedRecords.map(x => ({
      sroRequestItemID: x.sroRequestItemID,
      requestedArrivalDate: x.requestedArrivalDate ? (new Date(x.requestedArrivalDate)).toLocaleDateString('en-US').replace(/\u200E/g, '') : null,
      deliveryDateChangeReason: x.arrivalDateReasonChange || ''
    }));
    this.subscription.push(
      this.sraOrdersService.updateRequestDateForSelectedRecords(updatePayload).subscribe(
        (result) => {
          if (!isContinueClick) {
            this.toastrService.success("Details updated successfully.");
            this.loaderService.setLoaderStatus(false);
            this.closeSlider();
          } else {
            this.loaderService.setLoaderStatus(false);
            const el = document.querySelector('.close-btn') as HTMLElement;
            if (el) el.style.display = 'block';
            this.sliderModelService.setSraRequestDetailsCloseValue(true);
            this.closeSlider();

          }


        },
        error => {
          console.error('Error updating request details:', error);
          this.loaderService.setLoaderStatus(false);
        }));
  }
  
  get hasSelectedPastDate(): boolean {
    const selectedRecords = this.sraRequestDetailsDataSource?.data?.filter(x => x.isSelected === true) || [];

    if (selectedRecords.length === 0) {
      return false;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return selectedRecords.some(record => {
      if (!record.requestedArrivalDate) {
        return true; 
      }

      const [month, day, year] = record.requestedArrivalDate.split('/');
      const recordDate = new Date(+year, +month - 1, +day);
      recordDate.setHours(0, 0, 0, 0);

      return recordDate < today; 
    });
  }

  disableContinueBtn() : boolean{
    return this.sraRequestDetailsDataSource?.data?.some(x => x.isItemEligible == false);
  }
  isReasonRequired(item: any): boolean {
    return item.isReasonMandatory === true &&
      (!item.arrivalDateReasonChange || item.arrivalDateReasonChange === '');
  }
  ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
